var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_22469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9278 15.0734H5.03141L12.3009 7.80394L11.1973 6.70033L3.9278 13.9698V15.0734ZM16.4156 16.6344H2.36682V13.3228L12.8527 2.83691C12.999 2.6906 13.1975 2.6084 13.4045 2.6084C13.6114 2.6084 13.8099 2.6906 13.9563 2.83691L16.1643 5.04491C16.3106 5.19128 16.3928 5.38976 16.3928 5.59672C16.3928 5.80368 16.3106 6.00216 16.1643 6.14852L7.23941 15.0734H16.4156V16.6344ZM12.3009 5.59672L13.4045 6.70033L14.5081 5.59672L13.4045 4.49311L12.3009 5.59672V5.59672Z",
    fill: "#F8F9F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_22469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7317,
    height: 18.7317,
    fill: "white",
    transform: "translate(0.0253906 0.244141)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.be83843fc825be46303b4f69ca97fb98.svg";
export { ForwardRef as ReactComponent };